import * as React from "react";

function HeadingSection() {
  return (
    <header className="mb-32 max-sm:mb-20">
      <h1 className="mb-4 text-6xl font-bold leading-tight text-teal-600 max-sm:text-4xl">
        One System. Total Control.
      </h1>
      <h2 className="mb-8 text-4xl leading-tight text-amber-500 max-sm:text-3xl">
        Unified Platform. Infinite Potential.
      </h2>
      <p className="text-lg leading-relaxed text-gray-500 max-w-[960px] max-sm:text-base">
        Our mission: the Business OS—a single, unified ecosystem that frees
        you from app chaos and fragmented data. We deliver 'big tech' power
        with a sleek, accessible, and intuitive experience. Partnering with
        ambitious businesses, we create seamless solutions that empower
        growth. Technology is at its best when it fades into the background
        and enables focus. Our promise—total control, modern style.
      </p>
    </header>
  );
}

export default HeadingSection;
